import React, { useRef } from 'react';
import { IVoicemail } from '@/shared/interfaces/voicemail.interface';
import sound from '@/public/audio/Kalimba.mp3';
import { SoundPlayer } from '@/components/SoundPlayer';
import { CloseBtn } from '@/public/closeBtn';
import './index.scss';

type Props = {
  item: IVoicemail;
  setItemChosen: (value: IVoicemail) => void;
};

const initAudio = ({ src, isPlay }) => {
  const voicemailAudio = src ? new Audio(src) : new Audio(sound);

  return {
    play: () => {
      isPlay.current = true;
      return voicemailAudio.play();
    },
    pause: () => {
      isPlay.current = false;
      voicemailAudio.pause();
    },
    voicemailAudio,
  };
};

export function VoicemailItem({ item, setItemChosen }: Props) {
  const handleClose = () => {
    setItemChosen(null);
  };
  const isPlay = useRef(false);

  const { play, pause, voicemailAudio } = initAudio({
    src: item.recordurl,
    isPlay,
  });

  return (
    <div className="voicemail-recording">
      <button onClick={handleClose} className="close">
        <CloseBtn />
      </button>
      <div>
        <div className="name">Voicemail name {item.caller}</div>
        <div className="time">{item.time}</div>
        <hr />
        <SoundPlayer
          play={play}
          pause={pause}
          voicemailAudio={voicemailAudio}
        />
      </div>
    </div>
  );
}
